import { useEffect, useMemo } from 'react';
import { useParams, useLocation, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import GameCard from '@/components/base/GameCard';
import { gameCategories, allGames } from '@/mocks/games';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  const currentCategory = useMemo(
    () => gameCategories.find((c) => c.slug === slug),
    [slug]
  );

  const categoryGames = useMemo(
    () => (slug ? allGames.filter((g) => g.category === slug) : []),
    [slug]
  );

  const categoryName = currentCategory?.name || '游戏分类';

  return (
    <>
      <Navbar />
      <main className="pt-16">
        <div className="bg-background-100 border-b border-background-200">
          <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
            <Breadcrumb
              items={[
                { label: '首页', path: '/' },
                { label: '游戏分类', path: '/category/jingdian' },
                { label: categoryName },
              ]}
            />
            <div className="pb-8">
              <h1 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2">
                {categoryName}
              </h1>
              <p className="text-foreground-600 text-sm">
                {currentCategory?.description || '浏览全部游戏分类'}
              </p>
            </div>
          </div>
        </div>

        <div className="w-full px-4 md:px-6 max-w-6xl mx-auto py-6">
          <div className="flex items-center gap-2 mb-8 overflow-x-auto pb-2 flex-wrap">
            <Link
              to="/category/jingdian"
              className={`px-4 py-2 text-sm font-medium rounded-full whitespace-nowrap cursor-pointer transition-colors ${
                slug === 'jingdian' || !slug
                  ? 'bg-primary-500 text-white'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200'
              }`}
            >
              全部
            </Link>
            {gameCategories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 text-sm font-medium rounded-full whitespace-nowrap cursor-pointer transition-colors ${
                  slug === cat.slug
                    ? 'bg-primary-500 text-white'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>

          {categoryGames.length > 0 ? (
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 mb-12">
              {categoryGames.map((game) => (
                <GameCard
                  key={game.id}
                  id={game.id}
                  name={game.name}
                  category={game.category}
                  image={game.image}
                  rating={game.rating}
                  players={game.players}
                  isHot={game.isHot}
                  isNew={game.isNew}
                  categorySlug={slug}
                />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-background-100 rounded-full">
                <i className="ri-gamepad-line text-2xl text-foreground-400"></i>
              </div>
              <p className="text-foreground-500">该分类暂无游戏，请查看其他分类</p>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </>
  );
}